// Bold Commerce Upsell Integration
(function() {
  'use strict';

  // Wait for Bold to be loaded
  function initBoldUpsell() {
    if (typeof window.BOLD === 'undefined' || typeof window.BOLD.upsell === 'undefined') {
      // Bold not loaded yet, try again
      setTimeout(initBoldUpsell, 100);
      return;
    }

    // Initialize Bold Upsell on product pages
    if (document.querySelector('.bold-upsell-container')) {
      const containers = document.querySelectorAll('.bold-upsell-container');
      containers.forEach(function(container) {
        const productId = container.dataset.productId;
        const variantId = container.dataset.variantId;
        
        if (productId && variantId) {
          // Initialize Bold Upsell for this product
          if (window.BOLD.upsell && window.BOLD.upsell.init) {
            window.BOLD.upsell.init({
              productId: productId,
              variantId: variantId,
              container: container
            });
          }
        }
      });
    }

    // Initialize Bold Cart Upsell
    if (document.querySelector('.bold-cart-upsell-container')) {
      const cartContainers = document.querySelectorAll('.bold-cart-upsell-container');
      cartContainers.forEach(function(container) {
        const cartTotal = container.dataset.cartTotal;
        
        if (window.BOLD.upsell && window.BOLD.upsell.initCart) {
          window.BOLD.upsell.initCart({
            cartTotal: cartTotal,
            container: container
          });
        }
      });
    }

    // Initialize Bold Cart Drawer Upsell
    if (document.querySelector('.bold-cart-drawer-upsell-container')) {
      const drawerContainers = document.querySelectorAll('.bold-cart-drawer-upsell-container');
      drawerContainers.forEach(function(container) {
        const cartTotal = container.dataset.cartTotal;
        
        if (window.BOLD.upsell && window.BOLD.upsell.initCartDrawer) {
          window.BOLD.upsell.initCartDrawer({
            cartTotal: cartTotal,
            container: container,
            isDrawer: true
          });
        }
      });
    }

    // Re-initialize on variant change
    document.addEventListener('variant:change', function(event) {
      const variant = event.detail.variant;
      if (variant) {
        const container = document.querySelector('.bold-upsell-container');
        if (container) {
          container.dataset.variantId = variant.id;
          
          // Re-initialize Bold Upsell with new variant
          if (window.BOLD.upsell && window.BOLD.upsell.update) {
            window.BOLD.upsell.update({
              variantId: variant.id
            });
          }
        }
      }
    });

    // Re-initialize on cart update
    document.addEventListener('cart:updated', function(event) {
      const cart = event.detail.cart;
      if (cart) {
        // Update cart upsell containers with new total
        const cartContainers = document.querySelectorAll('.bold-cart-upsell-container, .bold-cart-drawer-upsell-container');
        cartContainers.forEach(function(container) {
          container.dataset.cartTotal = cart.total_price;
          
          // Re-initialize Bold Cart Upsell with new total
          if (window.BOLD.upsell && window.BOLD.upsell.updateCart) {
            window.BOLD.upsell.updateCart({
              cartTotal: cart.total_price
            });
          }
        });
      }
    });

    // Handle AJAX add to cart from Bold Upsell
    document.addEventListener('bold:upsell:add', function(event) {
      const items = event.detail.items;
      if (items && items.length > 0) {
        // Add items to cart via Shopify AJAX API
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: items
          })
        })
        .then(response => response.json())
        .then(data => {
          // Trigger cart update
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: data }
          }));
          
          // Open cart drawer if enabled (with lazy loading support)
          if (window.loadCartDrawer) {
            window.loadCartDrawer().then(() => {
              const drawer = document.querySelector('cart-drawer');
              if (drawer) drawer.open();
            });
          } else if (document.querySelector('cart-drawer')) {
            document.querySelector('cart-drawer').open();
          }
          
          // Refresh cart page if we're on it
          if (window.location.pathname === '/cart') {
            setTimeout(function() {
              window.location.reload();
            }, 1000);
          }
        })
        .catch(error => {
          console.error('Error adding Bold Upsell items to cart:', error);
        });
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBoldUpsell);
  } else {
    initBoldUpsell();
  }

  // Also re-initialize when cart drawer opens
  document.addEventListener('cart-drawer:open', function() {
    setTimeout(initBoldUpsell, 300);
  });
})();